import {
  CreatePoolController,
  ProtocolCatalogController,
  createProtocolApi,
  loadProtocolManifest,
  loadRuntimeManifest,
  type WalletBroadcaster,
} from "@zkresistor/shared";
import type { PrivateRuntime, ProofWorkerFactory } from "./private-runtime.js";

export interface ClientRuntime {
  catalog: ProtocolCatalogController;
  createPool: CreatePoolController;
  privateRuntime(): Promise<PrivateRuntime>;
}

export async function createClientRuntime(
  wallet: WalletBroadcaster,
  createWorker: ProofWorkerFactory,
): Promise<ClientRuntime> {
  const [manifest, runtime] = await Promise.all([loadProtocolManifest(), loadRuntimeManifest()]);
  const api = createProtocolApi({
    baseUrl: runtime.apiBaseUrl,
    signer: runtime.indexerSigningKey,
    protocolManifestSha256: runtime.protocolManifestSha256,
  });
  const catalog = new ProtocolCatalogController(api, manifest);
  let privateRuntime: Promise<PrivateRuntime> | null = null;
  return {
    catalog,
    createPool: new CreatePoolController(catalog, api, manifest, wallet),
    privateRuntime() {
      privateRuntime ??= import("./private-runtime.js").then(({ createPrivateRuntime }) =>
        createPrivateRuntime(manifest, api, wallet, createWorker));
      return privateRuntime;
    },
  };
}

export function resetTransfers(runtime: PrivateRuntime | null): void {
  runtime?.deposit.reset();
  runtime?.withdraw.reset();
}

export type { PrivateRuntime, ProofWorkerFactory } from "./private-runtime.js";
